# Bitcoin & open money
https://bitcoin.org
https://bitcoiner.guide
https://darosior.github.io
https://diyhpl.us
https://gnusha.org
https://mempool.space
https://bitcoinops.org
https://learnmeabitcoin.com
https://lightning.engineering
https://btctranscripts.com
https://bitcoin.page
https://bitcoinbriefly.com
https://nakamoto.com
https://unchained.com
https://keys.casa
https://blog.casa
https://ministryofnodes.com
https://bitcoinerjobs.co
https://hivemind.vc
https://spiral.xyz
https://opensats.org
https://hrf.org
https://bitcoinbeach.com
https://geyser.fund
https://bolt.fun
https://amboss.space
https://lightning.network
https://blockstream.com
https://bitcoinknots.org
https://bitcoincore.org
https://bisq.network
https://stacker.news
